
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4Wx0w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $735351e882105e81$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $735351e882105e81$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': 'Mit der Eingabe beginnen',
    'fabric.editor.editorAssistiveLabel': "Hauptinhaltsbereich\xa0\u2013 geben Sie hier Ihren Text ein.",
    'fabric.editor.headingLink.toolbarHelpTitle': "Hilfe \xf6ffnen"
};

});


//# sourceMappingURL=de.4caaf99a.js.map
